enum eInvoiceStatus {
  Open = 1,
  Close = 2,
  Reserved = 3,
}

export default eInvoiceStatus;
